export default __webpack_public_path__ + "static/media/courier-tracking-large-van.7a642a2b.svg";